export class FloorPlanLocationData {
    entity;
    entityId;
    coordinates; // [x, y]
    constructor() { }
    static fromApi(data) {
        if (Array.isArray(data)) {
            return data.map((et) => FloorPlanLocationData.define(et));
        }
        else if (data != null) {
            return FloorPlanLocationData.define(data);
        }
        else
            return null;
    }
    static define(data) {
        let locationData = new FloorPlanLocationData();
        locationData.entity = data.Entity;
        locationData.entityId = data.EntityId;
        locationData.coordinates = data.Coordinates;
        return locationData;
    }
}
